import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/invoice-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/InvoiceForm';
import { IInvoice } from 'src/types/invoice';

export interface StateProps {
    invoice: IInvoice | null;
    inProgress: boolean;
    files: any;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;
    addFiles: (id: string | number, files: any) => void;
    removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const InvoiceEditScreen: FC<Props> = (props: Props) => {
    const {
        invoice,
        inProgress,
        match: {
            params: { id },
        },
        getFiles,
        files,
        addFiles,
        removeFile,
        getData,
    } = props;

    useEffect(() => {
        if (!invoice || invoice.id !== id) {
            getData(id);
            getFiles(id);
        }
        // eslint-disable-next-line
    }, [getFiles, getData, id]);

    if (!invoice || inProgress) {
        return <Loader />;
    }
    const handeAdd = (files: any) => {
        addFiles(id, files);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };

    return (
        <RoleLayout>
            <div>
                <h2>INVOICES {`>`} EDIT INVOICE</h2>
            </div>
            <div className={classNames(styles.editWrap)}>
                <Form
                    files={files ? files : []}
                    setFiles={handeAdd}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{ ...invoice }}
                />
            </div>
        </RoleLayout>
    );
};
export default InvoiceEditScreen;
